export const formatDate = (date) => {
  if (date) {
    return new Intl.DateTimeFormat("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(new Date(date));
  }
  return "-";
};

export const formatDateTime = (date) => {
  if (date) {
    const d = new Date(date);
    const formattedDate = new Intl.DateTimeFormat("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(d);
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${formattedDate} ${hours}:${minutes}:${seconds}`;
  }
  return "-";
};
